import { useEffect } from 'react';
import { useAppointmentProposals } from '../../../../data-access/appointmentProposals';
import StartServiceCallButton from '../../../proposal-navigation/Buttons/StartServiceCallButton';

interface ServiceCallActionProps {
  appointmentId: string;
}

const ServiceCallAction: React.FC<ServiceCallActionProps> = ({
  appointmentId,
}) => {
  const { proposals, fetchAppointmentProposals } = useAppointmentProposals();

  useEffect(() => {
    fetchAppointmentProposals(appointmentId);
  }, [appointmentId, fetchAppointmentProposals]);

  const proposal = proposals.find(Boolean);

  return (
    <StartServiceCallButton appointmentId={appointmentId} proposal={proposal} />
  );
};

export default ServiceCallAction;
